import { render } from "./VideoGen.vue?vue&type=template&id=97325a90&scoped=true"
import script from "./VideoGen.vue?vue&type=script&lang=js"
export * from "./VideoGen.vue?vue&type=script&lang=js"

import "./VideoGen.vue?vue&type=style&index=0&id=97325a90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97325a90"]])

export default __exports__